import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=0539398e&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"
import style0 from "./EventList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EventList.vue?vue&type=style&index=1&id=0539398e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539398e",
  null
  
)

export default component.exports